import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';

@HateoasResource('integrations', { routeName: 'integrationsResourceRoute' })
export class ScimIntegration extends Resource {
    id;
    networkId;
    networkGroupId;
    name;
    integrationKey: string;
    jwtConnectionId;
    serviceIdentityId;
    defaultTokenTTLDays: number;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
    appliedAt: string;
    deletedAt: string;
    deletedBy: string;
    deleted: string;
    resourceState: string;
    selected: boolean;
}

export class ScimIntegrationUpdate {
    name: string;
}